import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱情岛路线导航',
    url: 'https://aiqingdao-line.com',
    description: '致力于为用户提供爱情岛一论坛最新免费路线入口、访问教程和使用技巧。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 爱情岛一论坛免费路线导航"
        description="爱情岛路线导航致力于为用户提供爱情岛一论坛最新免费路线入口、访问教程和使用技巧。了解我们的品牌故事、用户口碑和联系方式。"
        keywords="爱情岛路线导航,关于我们,品牌介绍,联系方式,论坛路线导航"
        canonicalUrl="https://aiqingdao-line.com/about"
        schemaJson={orgSchema}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb items={breadcrumbItems} />
            </div>
          </div>

          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
                关于我们
              </h1>
              <p className="text-foreground-600 text-base leading-relaxed mb-12">
                爱情岛路线导航是一个专注于提供论坛免费路线访问指南的信息聚合平台。
              </p>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
                <div className="lg:col-span-2 space-y-8">
                  <div>
                    <h2 className="text-xl font-semibold font-heading text-foreground-900 mb-4">品牌介绍</h2>
                    <p className="text-foreground-600 leading-relaxed mb-4">
                      爱情岛路线导航成立于2024年，是国内领先的论坛路线导航服务平台。我们专注于为用户提供最新、最全、最稳定的论坛访问路线信息，帮助广大用户快速、安全地访问所需论坛资源。
                    </p>
                    <p className="text-foreground-600 leading-relaxed mb-4">
                      我们的团队由一群热爱互联网的技术爱好者组成，每天持续监控路线状态，确保信息的时效性和准确性。无论是新手用户还是资深用户，都能在这里找到适合自己的访问方式。
                    </p>
                    <p className="text-foreground-600 leading-relaxed">
                      我们始终坚持免费服务的原则，所有路线信息和教程均免费提供。我们相信，优质的导航服务不应该成为用户的负担。
                    </p>
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold font-heading text-foreground-900 mb-4">我们的优势</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {[
                        { icon: 'ri-timer-flash-line', title: '实时更新', desc: '每日监控路线状态，第一时间更新最新可用路线' },
                        { icon: 'ri-shield-check-line', title: '安全可靠', desc: '所有路线经过严格验证，确保来源安全可靠' },
                        { icon: 'ri-smartphone-line', title: '多端适配', desc: '支持电脑端和手机端访问，教程覆盖全平台' },
                        { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '提供详细的教程和FAQ，帮助用户快速解决问题' },
                      ].map((item) => (
                        <div key={item.title} className="p-5 rounded-2xl bg-background-100 border border-background-200/70">
                          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                            <i className={`${item.icon} text-lg`}></i>
                          </div>
                          <h3 className="text-sm font-semibold font-heading text-foreground-900 mb-1.5">{item.title}</h3>
                          <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold font-heading text-foreground-900 mb-4">用户口碑</h2>
                    <div className="space-y-4">
                      {[
                        { name: '张先生', rating: 5, text: '路线更新很及时，每次论坛地址变了都能第一时间在这里找到新的，收藏了！' },
                        { name: '李女士', rating: 5, text: '教程写得很详细，作为新手也能轻松跟着步骤操作，非常感谢！' },
                        { name: '王同学', rating: 4, text: '手机端的教程特别实用，终于可以在手机上方便地访问论坛了。' },
                        { name: '赵先生', rating: 5, text: '分类很清晰，想找什么内容一目了然。路线可用率确实很高，基本没遇到过不能用的情况。' },
                      ].map((review, idx) => (
                        <div key={idx} className="p-5 rounded-2xl bg-background-100 border border-background-200/70">
                          <div className="flex items-center gap-3 mb-2">
                            <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                              <span className="text-sm font-semibold text-primary-600">{review.name.charAt(0)}</span>
                            </div>
                            <div>
                              <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                              <div className="flex items-center gap-0.5">
                                {Array.from({ length: 5 }).map((_, i) => (
                                  <i
                                    key={i}
                                    className={`text-xs ${i < review.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                                  ></i>
                                ))}
                              </div>
                            </div>
                          </div>
                          <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="p-6 rounded-2xl bg-background-100 border border-background-200/70 sticky top-24">
                    <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-4">联系方式</h3>
                    <div className="space-y-4">
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                          <i className="ri-mail-line"></i>
                        </div>
                        <div>
                          <div className="text-xs text-foreground-500 mb-0.5">电子邮箱</div>
                          <div className="text-sm text-foreground-800">contact@aiqingdao-line.com</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                          <i className="ri-time-line"></i>
                        </div>
                        <div>
                          <div className="text-xs text-foreground-500 mb-0.5">工作时间</div>
                          <div className="text-sm text-foreground-800">周一至周日 9:00 - 21:00</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                          <i className="ri-shield-check-line"></i>
                        </div>
                        <div>
                          <div className="text-xs text-foreground-500 mb-0.5">反馈响应</div>
                          <div className="text-sm text-foreground-800">24小时内回复</div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-6 pt-6 border-t border-background-200/70">
                      <h4 className="text-sm font-semibold text-foreground-900 mb-3">快速反馈</h4>
                      <p className="text-xs text-foreground-600 mb-4">
                        如果您发现路线不可用或有任何建议，欢迎随时联系我们。
                      </p>
                      <a
                        href={`mailto:contact@aiqingdao-line.com`}
                        className="inline-flex items-center gap-2 w-full justify-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-send-plane-line"></i>
                        发送邮件
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-background-200/70 pt-12">
                <h2 className="text-xl font-semibold font-heading text-foreground-900 mb-6 text-center">发展历程</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {[
                    { year: '2024年3月', title: '平台成立', desc: '爱情岛路线导航正式上线，开始提供论坛免费路线导航服务' },
                    { year: '2024年8月', title: '内容扩展', desc: '新增访问教程和使用技巧分类，丰富了网站内容体系' },
                    { year: '2025年1月', title: '移动端优化', desc: '全面优化移动端访问体验，新增手机端专属教程' },
                    { year: '2026年至今', title: '持续优化', desc: '每日更新路线状态，持续提供高质量的路线导航服务' },
                  ].map((milestone, idx) => (
                    <div key={idx} className="p-5 rounded-2xl bg-background-100 border border-background-200/70 text-center">
                      <div className="text-sm font-bold text-primary-600 font-heading mb-2">{milestone.year}</div>
                      <div className="text-sm font-semibold text-foreground-900 mb-1.5">{milestone.title}</div>
                      <p className="text-xs text-foreground-600 leading-relaxed">{milestone.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}